export async function diagnoseNetworkError(url: string) {
    try {
        const response = await fetch(url, {
            method: "GET",
            mode: "cors",
            credentials: "include",
        });

        return new NetworkError(response);
    } catch (err) {
        const fetchError = err as Error;
        return {
            error: fetchError.message,
            type: fetchError.name,
            stack: fetchError.stack,
        };
    }
}

export class NetworkError extends Error {
    public readonly status: HttpCode;
    public readonly statusText: string;
    public readonly ok: boolean;
    public readonly headers: Record<string, string>;

    public constructor(response: Response) {
        super("Network error occurred.");

        this.status = response.status;
        this.statusText = response.statusText;
        this.ok = response.ok;
        this.headers = Object.fromEntries(response.headers.entries());
    }

    public override toString(): string {
        const header = `${NetworkError.name}: ${this.message}`;
        const body = `  Info: ${JSON.stringify(this)}`;

        return `${header}\n${body}`;
    }
}

export const enum HttpCode {
    NotFound = 404,
}

export const isNetworkError = (obj: unknown): obj is NetworkError => obj instanceof NetworkError;
